import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import { Stack, Button, Text } from '@moda/om';
import { PumoModuleSlide, PUMO_MODULE_SLIDE_FRAGMENT } from '../PumoModuleSlide';
import { PumoLivestreamModuleFragment } from '../../generated/types/PumoLivestreamModuleFragment';
import { loadBambuser } from '../../lib/bambuser';

import './PumoLivestreamModule.scss';

export interface Props {
  livestream: PumoLivestreamModuleFragment;
}

export const PUMO_LIVESTREAM_MODULE_FRAGMENT = gql`
  fragment PumoLivestreamModuleFragment on LivestreamPumoModule {
    id
    slides {
      ...PumoModuleSlideFragment
    }
    livestreamId: livestream_id
    headlineBody: headline_body
    ctaBeforeShowText: cta_before_show_text
    ctaAfterShowText: cta_after_show_text
    startDate: start_date
  }
  ${PUMO_MODULE_SLIDE_FRAGMENT}
`;

export const PumoLivestreamModule: React.FC<Props> = ({ livestream }) => {
  const ctaText =
    new Date(livestream.startDate) < new Date()
      ? livestream.ctaAfterShowText
      : livestream.ctaBeforeShowText;

  useEffect(() => {
    loadBambuser(livestream.livestreamId);
  }, [livestream.livestreamId]);

  return (
    <div className="PumoLivestreamModule">
      <div className="PumoLivestreamModule__image">
        {livestream.slides.map((slide, index) => (
          <PumoModuleSlide key={index} slide={slide} className="PumoLivestreamModule__image" />
        ))}
      </div>
      <Stack className="PumoLivestreamModule__side" space={4} justifyContent="center">
        <Text
          dangerouslySetInnerHTML={{
            __html: livestream.headlineBody
          }}
        />
        <Button
          className="PumoLivestreamModule__button"
          id={`liveshopping-${livestream.livestreamId}`}
        >
          {ctaText}
        </Button>
      </Stack>
    </div>
  );
};
